




















import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import TableOfContents from "@/components/Molecules/TableOfContents/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { DISABLED_ITEM_TYPE } from "@/constants/eventExperience";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventExperienceSteps",
  components: {
    Heading,
    TableOfContents
  },
  props: {
    steps: {
      type: Array as PropType<Props["steps"]>,
      required: true
    },
    focusStepId: {
      type: Number,
      default: 0
    },
    isNewExperience: {
      type: Boolean as PropType<Props["isNewExperience"]>,
      default: false
    }
  },
  methods: {
    formattedItems(selectionReportItems) {
      return selectionReportItems.map(e => {
        return {
          label: e.item_type,
          url: this.disabledLink(e) ? undefined : `/event-experiences/${e.id}`
        };
      });
    },
    disabledLink(selectionReportItem) {
      return (
        selectionReportItem.id === this.focusStepId ||
        DISABLED_ITEM_TYPE.includes(selectionReportItem.item_type)
      );
    }
  }
});
